module.exports = __webpack_public_path__ + "static/img/spread1-1.c46954b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread1-1.jpg
// module id = BIrg
// module chunks = 1